import React, { useEffect } from 'react'
import { clearUser, setUser } from 'slices/user.slice'
import { useAppDispatch } from 'store'
import { getToken } from 'utils'
import API from 'utils/api'

export interface IUserToken {
  token: string
}

export function useToken() {
  const dispatch = useAppDispatch()

  const [token, setToken] = React.useState<string | undefined>(() => getToken())
  const [loading, setLoading] = React.useState<boolean>(false)
  const saveToken = (userToken: IUserToken) => {
    localStorage.setItem('token', JSON.stringify(userToken))
    setToken(userToken.token)
  }

  // for validating the token
  useEffect(() => {
    const validateToken = async () => {
      try {
        setLoading(true)
        const response = await API.post(
          `/auth/verify`,
          {
            token,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
        const user = response.data
        dispatch(setUser(user))
      } catch (error: unknown) {
        if (typeof error === 'object' && error && 'response' in error) {
          setToken(undefined)
          dispatch(clearUser())
          localStorage.removeItem('token')
        }
      } finally {
        setLoading(false)
      }
    }
    if (token) {
      validateToken()
    }

    return () => {}
  }, [token, dispatch])

  return { setToken: saveToken, token, loading }
}
